module.exports = "/packs/images/components/search/ku-gridview~30b1e5b105c8d9ddb98074d0bf287a2f.png";